export const DEFAULT_STORAGE_ENGINE = 'localStorage';
